import _classCallCheck from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/rewyer/sites/rewyer-client-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module core/editingkeystrokehandler
 */
import KeystrokeHandler from '@ckeditor/ckeditor5-utils/src/keystrokehandler';
/**
 * A keystroke handler for editor editing. Its instance is available
 * in {@link module:core/editor/editor~Editor#keystrokes} so plugins
 * can register their keystrokes.
 *
 * E.g. an undo plugin would do this:
 *
 *		editor.keystrokes.set( 'Ctrl+Z', 'undo' );
 *		editor.keystrokes.set( 'Ctrl+Shift+Z', 'redo' );
 *		editor.keystrokes.set( 'Ctrl+Y', 'redo' );
 *
 * @extends module:utils/keystrokehandler~KeystrokeHandler
 */

var EditingKeystrokeHandler = /*#__PURE__*/function (_KeystrokeHandler) {
  _inherits(EditingKeystrokeHandler, _KeystrokeHandler);

  var _super = _createSuper(EditingKeystrokeHandler);

  /**
   * Creates an instance of the keystroke handler.
   *
   * @param {module:core/editor/editor~Editor} editor
   */
  function EditingKeystrokeHandler(editor) {
    var _this;

    _classCallCheck(this, EditingKeystrokeHandler);

    _this = _super.call(this);
    /**
     * The editor instance.
     *
     * @readonly
     * @member {module:core/editor/editor~Editor}
     */

    _this.editor = editor;
    return _this;
  }
  /**
   * Registers a handler for the specified keystroke.
   *
   * The handler can be specified as a command name or a callback.
   *
   * @param {String|Array.<String|Number>} keystroke Keystroke defined in a format accepted by
   * the {@link module:utils/keyboard~parseKeystroke} function.
   * @param {Function|String} callback If a string is passed, then the keystroke will
   * {@link module:core/editor/editor~Editor#execute execute a command}.
   * If a function, then it will be called with the
   * {@link module:engine/view/observer/keyobserver~KeyEventData key event data} object and
   * a `cancel()` helper to both `preventDefault()` and `stopPropagation()` of the event.
   * @param {Object} [options={}] Additional options.
   * @param {module:utils/priorities~PriorityString|Number} [options.priority='normal'] The priority of the keystroke
   * callback. The higher the priority value the sooner the callback will be executed. Keystrokes having the same priority
   * are called in the order they were added.
   */


  _createClass(EditingKeystrokeHandler, [{
    key: "set",
    value: function set(keystroke, callback) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof callback == 'string') {
        var commandName = callback;

        callback = function callback(evtData, cancel) {
          _this2.editor.execute(commandName);

          cancel();
        };
      }

      _get(_getPrototypeOf(EditingKeystrokeHandler.prototype), "set", this).call(this, keystroke, callback, options);
    }
  }]);

  return EditingKeystrokeHandler;
}(KeystrokeHandler);

export { EditingKeystrokeHandler as default };